// Raw Playwright JSON types — re-exported from @playwright/test/reporter as
// the single source of truth. If Playwright changes the JSON reporter schema,
// these aliases break at build time so we notice instead of silently parsing
// the wrong shape.
//
// View-layer concepts (TestResultStatus / DisplayTestStatus) stay here — they
// are the dashboard's own normalized model, not Playwright's emitted shape.

import type {
    JSONReportSpec,
    JSONReportSuite,
    JSONReportTest,
    JSONReportTestResult,
} from "@playwright/test/reporter";

export enum TestResultStatus {
    Passed = "passed",
    Failed = "failed",
    TimedOut = "timedOut",
    Skipped = "skipped",
}

export enum DisplayTestStatus {
    Passed = "Passed",
    Flaky = "Flaky",
    Failed = "Failed",
    Skipped = "Skipped",
    NoResults = "No results",
    Unknown = "Unknown",
}

/** Single attachment entry from a Playwright test result.
 *  Mirrors @playwright/test/reporter's inline attachment shape. */
export type TestAttachment = JSONReportTestResult["attachments"][number];

/** One Playwright test result (one attempt of one project). */
export type TestResult = JSONReportTestResult;

/** One test entry within a spec — represents one project's run of the spec. */
export type Test = JSONReportTest;

/** One Playwright spec (the leaf — a single `test()` declaration). */
export type TestSpec = JSONReportSpec;

/** A suite node in the Playwright JSON tree.
 *  Top-level suites are one-per-file; child suites are `describe()` blocks. */
export type TestSuite = JSONReportSuite;
